import * as React from 'react';
import Svg, {Path, G, Mask} from 'react-native-svg';

const AlertCircleExclamation = () => (
  <Svg width={79} height={78} viewBox="0 0 79 78" fill="none">
    {/* Define Mask */}
    <Mask id="mask1" x="7" y="6" width="65" height="66">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.5 6.5C21.625 6.5 7 21.125 7 39s14.625 32.5 32.5 32.5S72 56.875 72 39 57.375 6.5 39.5 6.5zm3.75 48.75h-7.5V49h7.5v6.25zm0-13.75h-7.5v-20h7.5v20z"
        fill="#fff"
      />
    </Mask>

    {/* Background */}
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.5 6.5C21.625 6.5 7 21.125 7 39s14.625 32.5 32.5 32.5S72 56.875 72 39 57.375 6.5 39.5 6.5zm3.75 48.75h-7.5V49h7.5v6.25zm0-13.75h-7.5v-20h7.5v20z"
      fill="#D7263D"
    />

    {/* Apply Mask */}
    <G mask="url(#mask1)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.5 6.5C21.625 6.5 7 21.125 7 39s14.625 32.5 32.5 32.5S72 56.875 72 39 57.375 6.5 39.5 6.5zm3.75 48.75h-7.5V49h7.5v6.25zm0-13.75h-7.5v-20h7.5v20z"
        fill="#D7263D"
      />
    </G>
  </Svg>
);
export default AlertCircleExclamation;
